import script from "./DiversItemModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiversItemModal.vue?vue&type=script&setup=true&lang=ts"

import "./DiversItemModal.vue?vue&type=style&index=0&id=6bcf8934&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bcf8934"]])

export default __exports__